<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-datepicker
              name="a_partire_dal"
              label="Dal"
              v-model="filter.a_partire_dal"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>
    <b-overlay center :show="isLoading" rounded="sm">
      <b-card class="filter mt-2 mb-4" v-if="filter.conto && search">
        <div class="col-md-12">
          <cash-control v-if="!isLoading" :totals="data" />
        </div>
      </b-card>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
    <div></div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseIcon from "@/components/BaseIcon";
import { mapActions, mapGetters } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import { today } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import CashControl from "@/components/cashControl";
import moment from "moment";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

moment.locale("it");
export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "cash_entry",
      resource: "movimenti_prima_nota",
      filterName: "filterControlloDiCassa",
      cash_references_opt: [],
      treasuries_opt: [],
      contoPrimaNota: "PNC",
      filter: this.initFilter(),
      performedSearch: false,
      activeFilters: {},
      data: 0,
      isLoading: false,
      search: false,
    };
  },
  components: {
    BaseDatepicker,
    BaseIcon,
    CashControl,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    toLocaleCurrency,
    toLocaleDate,
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.search = false;
      this.data = 0;
      this.performedSearch = false;
      this.open_filter = true;
    },
    initFilter() {
      let init = {
        a_partire_dal: today(),
        fino_al: today(),
        produttore: null,
        causale: null,
        conto: null,
        compagnia: [],
        foglio_cassa: null,
        controllo_cassa: null,
      };
      return init;
    },
    onSearch() {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (this.filter.a_partire_dal && this.filter.conto) {
        this.isLoading = true;
        this.filter.fino_al = this.filter.a_partire_dal;
        const Repo = RepositoryFactory.get(this.repository);
        const queryString = `a_partire_dal=${this.filter.a_partire_dal}&fino_al=${this.filter.fino_al}&conto=${this.filter.conto}`;
        Repo.saldoContoCassa(queryString)
          .then((response) => {
            this.data = response?.data?.saldo ? response.data.saldo : 0;
            this.$showSnackbar({
              preset: "success",
              text: `Calcolo 'Saldo Conto' terminato`,
            });
            this.search = true;
            this.isLoading = false;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
            this.isLoading = false;
          });
      } else {
        if (!this.filter.conto) {
          this.$showSnackbar({
            preset: "error",
            text: `Attenzione: non risulta alcun conto collegato`,
          });
        } else {
          this.$showSnackbar({
            preset: "success",
            text: `Devi impostare una data`,
          });
        }
      }
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["conto"];
      delete this.activeFilters["foglio_cassa_compagnia"];

      return this.activeFilters;
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getCashReferences: "cash_references",
      getContiPrimaNota: "allContiPrimaNota",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  created() {
    let cashReferences = this.getCashReferences();
    cashReferences.sort((a, b) => a.text - b.text);
    cashReferences.forEach((el) => {
      this.cash_references_opt.push({
        text: `${el.text} - ${el.description}`,
        reference_type: el.reference_type,
        has_broker: el.has_broker,
        has_company: el.has_company,
        entry_type: el.entry_type,
        value: el.value,
        treasury_id: el.treasury_id,
      });
    });
    this.treasuries_opt = this.getContiPrimaNota();
    this.filter.conto = this.treasuries_opt.find(
      (treasury) => treasury.code === this.contoPrimaNota,
    )?.value;
  },
  beforeMount() {
    this.removeFilterByName(this.filterName);
  },
};
</script>
<style scoped></style>
